import { showDefaultToast } from '@/components/ui/toaster'

import { getErrorMessage } from '../error/message'
import { sentryConfig } from '../error/sentry'
import { isDebugModeEnabled } from '../html/env'
import { isServerSide } from '../html/server-side'

export class Logger {
  static info(...args: unknown[]) {
    console.log(...args)
  }

  static warning(...args: unknown[]) {
    console.warn(...args)
  }

  static error(error: Error | string, ...args: unknown[]) {
    if (error instanceof Error) {
      console.error(error, getErrorMessage(error, { obscureServerErrors: false }), ...args)
    } else {
      console.error(error, ...args)
    }
    sentryConfig.capture(error, ...args)
  }

  static debug(...args: unknown[]) {
    console.debug(...args)

    if (isDebugModeEnabled()) {
      if (!isServerSide()) {
        let message = args.join(' ')
        message = `[DEBUG]: ${message}`
        showDefaultToast(message)
      }
    }
  }
}
